// The honest placeholder.
//
// A scaffold that renders an empty shell teaches nobody anything. This
// shows exactly what the destination is for, which classic routes it takes
// over, and where to go meanwhile — so the porting map is legible from
// inside the product rather than only in a document.

import React from 'react';
import { PageHead, ui } from '../components/ui';
import { findItem } from '../shell/nav';
import { useLocation } from 'react-router-dom';

export default function Stub() {
  const { pathname } = useLocation();
  const item = findItem(pathname);
  if (!item) return <PageHead title="Not found" sub={`No V2 destination is registered at ${pathname}.`} />;

  return (
    <>
      {/* A destination with no classic route (from: [] — the Pane domain's seven, W7 OP-1) must not claim classic owns it. */}
      <PageHead title={item.label} sub={item.from.length
        ? 'Not built yet. Classic still owns this job — the link below goes straight there.'
        : 'Not built yet. No classic screen has ever done this job — what it is for is below.'} />
      <div className={ui.stubCard}>
        <div className={ui.stubRow}>
          <div className={ui.stubKey}>Why it exists</div>
          <div className={ui.stubVal}>{item.why}</div>
        </div>
        <div className={ui.stubRow}>
          <div className={ui.stubKey}>Ports from</div>
          <div className={ui.stubVal}>
            {item.from.length
              ? item.from.map((p) => (
                  <span key={p} style={{ marginRight: 10, display: 'inline-block' }}>
                    <a href={p.includes(':') ? p.split('/:')[0] : p} style={{ color: 'var(--iris-text)' }}>
                      <code>{p}</code>
                    </a>
                  </span>
                ))
              : <em>Nothing — this job has no classic screen.</em>}
          </div>
        </div>
        <div className={ui.stubRow}>
          <div className={ui.stubKey}>V2 path</div>
          <div className={ui.stubVal}><code>{item.path}</code></div>
        </div>
      </div>
    </>
  );
}
